var _path;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.4849 20.7131L22.5993 18.8275L24.4849 16.9419C27.0884 14.3384 27.0884 10.1173 24.4849 7.51383C21.8814 4.91032 17.6602 4.91032 15.0568 7.51383L13.1712 9.39944L11.2855 7.51383L13.1712 5.6282C16.8161 1.98331 22.7256 1.98331 26.3705 5.6282C30.0154 9.27309 30.0154 15.1826 26.3705 18.8275L24.4849 20.7131ZM20.7136 24.4844L18.828 26.37C15.1832 30.0148 9.27358 30.0148 5.62869 26.37C1.9838 22.7251 1.9838 16.8155 5.62869 13.1707L7.5143 11.2851L9.39993 13.1707L7.5143 15.0563C4.91081 17.6598 4.91081 21.8808 7.5143 24.4844C10.1178 27.0879 14.3389 27.0879 16.9424 24.4844L18.828 22.5987L20.7136 24.4844ZM19.7708 10.3423L21.6565 12.2279L12.2284 21.6559L10.3427 19.7703L19.7708 10.3423Z",
    fill: "#96E06E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLink);
export default __webpack_public_path__ + "static/media/link.6a16f4c0031aa7ff0b0746cae598dc63.svg";
export { ForwardRef as ReactComponent };